import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const AddAdminModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "AddAdminModalContainer" */
      './AddAdminModalContainer'
    ),
  loading: LoadingModal,
});
